import "./panel.scss";

import * as _ from "lodash";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { connect } from "react-redux";

import actions from "@/actions";
import { getModeLights, getSelectedLights } from "@/selectors";
import { Map } from "@/utils";

import Panel from "../base/Panel";
import InputCounter from "./input-counter/index";
import * as DirectionComponets from "./panel-buttons/index";

const MovePanel = ({
    selectedLights,
    mode,
    moveDistanceNumber,
    lights,
    changeLights,
    onChangeMoveDistanceNumber,
    toastr,
}) => {
    const handleChangeLights = useCallback(
        (direction) => {
            const historyStateProp = mode === "view" ? "global" : "mode";
            const changedLights = [];
            _.each(selectedLights, (selectedLight) => {
                const light = _.cloneDeep(selectedLight);
                const updatedPosition = Map.moveLight(
                    direction,
                    light.position,
                    moveDistanceNumber,
                );
                light.oldValue = _.get(light, "position");
                _.set(light, "position", updatedPosition);
                light.changed = true;
                changedLights.push(light);
            });
            const IsOverlapping = _.some(changedLights, (selectedLight) =>
                selectedLight.isOverlapping([...lights, ...changedLights]),
            );
            if (IsOverlapping) {
                _.each(changedLights, (selectedLight) => {
                    _.set(selectedLight, "position", selectedLight.oldValue);
                    delete selectedLight.changed;
                    delete selectedLight.oldValue;
                });
                toastr(
                    "We couldn't place all of the lights in your array. The skipped lights were either out of bounds of the map dimensions, or overlapped existing lights.",
                    "warning",
                );
            } else {
                changeLights(historyStateProp, changedLights);
            }
        },
        [
            selectedLights,
            mode,
            moveDistanceNumber,
            lights,
            changeLights,
            toastr,
        ],
    );

    const commonProps = {
        style: {
            minWidth: 90,
            paddingTop: 10,
        },
        color: "#FFF",
        className: "tools-bar-button",
    };
    const directions = ["Right", "Left", "Up", "Down"];
    const components = directions.map((direction) => {
        const element = DirectionComponets[`Move${direction}Button`];
        return React.createElement(element, {
            ...commonProps,
            title: `Move ${direction}`,
            key: direction,
            onClick: () => handleChangeLights(direction),
        });
    });

    components.push(
        <InputCounter
            key="input-counter"
            value={moveDistanceNumber}
            onChange={onChangeMoveDistanceNumber}
        />,
    );

    return (
        <Panel title="Move" className="move-panel">
            {components}
        </Panel>
    );
};

MovePanel.propTypes = {
    selectedLights: PropTypes.array,
    mode: PropTypes.string,
    moveDistanceNumber: PropTypes.number,
    lights: PropTypes.array,
    changeLights: PropTypes.func.isRequired,
    onChangeMoveDistanceNumber: PropTypes.func.isRequired,
    toastr: PropTypes.func.isRequired,
};

const mapStateToProps = ({ map }) => ({
    lights: _.values(_.cloneDeep(getModeLights({ map }))),
    selectedLights: getSelectedLights({ map }),
    mode: map.general.mode.name,
    moveDistanceNumber: map.move.moveDistanceNumber,
    position: map.move.position,
});
const mapDispatchToProps = {
    changeLights: (mode, lights) =>
        actions.map.values[mode].updateLights(lights),
    onChangeMoveDistanceNumber: (value) =>
        actions.map.move.onChangeMoveDistanceNumber(value),
    toastr: actions.window.showMessage,
};
export default connect(mapStateToProps, mapDispatchToProps)(MovePanel);
